module.exports = {"id":"199809","name":"Tino-Sven Sušić","rating":"71","photo":"./data/images/photos/2/199809.png","club":{"name":"Antwerp","logo":"./data/images/clubs/Antwerp.png"},"positions":["MC","MOC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Tino-SvenSusic0.json
// module id = 4150
// module chunks = 0